import type { GeneralObject } from '@scansource-brazil/zeus-core-ui/types';
import type { MySsApiResponse } from '~/types/MySsApiResponse';
import type { ApiResponse } from '~/types/ApiResponse';

import { AdaptCompany } from '~/adapters/CompanyAdapter';
import { Company } from '../models/Company';
import HttpService from './httpService';

const get = HttpService.get;

const baseUrl = 'companies';

export async function getCompanyByDocument(companyDocument: string) {
  return get(baseUrl, { params: { companyDocument } }).then(
    (response: any) => AdaptCompany.toModel(response.data.data.at(0)),
    (error) => {
      throw error;
    },
  );
}

export async function getEconomicGroupMembers(companiesDocuments: string[]): Promise<Company[]> {
  const queryParams = companiesDocuments.map((doc: any) => `CompanyDocument=${doc}`).join('&');
  return await get(`${baseUrl}?${queryParams}`).then(
    (response: any) => {
      return AdaptCompany.toModelList(response.data.data);
    },
    (error) => {
      throw error;
    },
  );
}

export async function listCommissionsTotalizers(
  companyDocument: string,
  params: GeneralObject = {},
) {
  return await get(`${baseUrl}/${companyDocument}/sales-commissions/summary`, { params }).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}

export async function listCommissions(
  companyDocument: string,
  params = new SalesCommissionFilters().toDto({} as SalesCommissionFilters),
) {
  return await get(`${baseUrl}/${companyDocument}/sales-commissions`, { params }).then(
    (response: ApiResponse<any[], { pagination: any }>) => {
      const items = response.data.data;
      const pagination = response.data.metadata?.pagination;
      return { items, pagination, success: response.data.success };
    },
    (error) => {
      throw error;
    },
  );
}

export async function showCommission(
  companyDocument: string,
  salesCommissionId: string,
): Promise<any> {
  return await get(`${baseUrl}/${companyDocument}/sales-commissions/${salesCommissionId}`).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}

export async function downloadAllCommissions(
  companyDocument: string,
  params: SalesCommissionFiltersDto,
) {
  try {
    return await get(`${baseUrl}/${companyDocument}/sales-commissions/export`, {
      params,
      responseType: 'blob',
    }).then(
      ({ data }: any) => {
        downloadFileBlob(data, `MEUS_AGENCIAMENTOS.xlsx`);
      },
      (error: any) => {
        throw errorTreatment(error);
      },
    );
  } catch (error: any) {
    const err = errorTreatment(error);
    throw err;
  }
}
